import { render, staticRenderFns } from "./message-freestyle-signup-prescription.vue?vue&type=template&id=f28a0ff0&scoped=true"
import script from "./message-freestyle-signup-prescription.vue?vue&type=script&lang=js"
export * from "./message-freestyle-signup-prescription.vue?vue&type=script&lang=js"
import style0 from "./message-freestyle-signup-prescription.vue?vue&type=style&index=0&id=f28a0ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28a0ff0",
  null
  
)

export default component.exports